import React from "react"
import { GameButton, Link } from "@fedsim/components"

import { Add } from "icons"

import { routesList } from 'constants/routes'

export function ImportBrandButton({ id }) {
  const link = `/#${routesList.QUICKMODE.path.replace(':id', id)}`

  return (
    <Link href={link} underline="none" color="white">
      <GameButton
        color="success"
        variant="contained"
        startIcon={<Add />}>
        Import {id}
      </GameButton >
    </Link>
  )
}

export default ImportBrandButton
